import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqGroups } from "@/mocks/site";

export default function FaqPreview() {
  const items = faqGroups.flatMap((group) => group.items).slice(0, 4);

  return (
    <section className="w-full px-5 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
        <div className="lg:w-[38%]">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-primary-600 font-medium">
            <span className="w-5 h-px bg-primary-400" />
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            关于阅读、内容原则与线索的几个问题
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            整理事件时会遇到很多共性问题，我们把读者问得最多的几条单独列了出来。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            查看全部问答
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="lg:w-[62%]">
          <FaqAccordion items={items} />
        </div>
      </div>
    </section>
  );
}